import React from 'react';
import ReportsLanding from '../../components/modules/Reports/ReportsLanding';

const Reports = () => {
  return <ReportsLanding />;
};

export default Reports;
